export default "__VITE_ASSET__FoY086di__"